<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>
		<b-row class="mt-3">
			<b-col cols="6">
				<b-form-group
					label="Code:"
					for="code"
				>
					<b-input
						id="code"
						v-model="code.Code"
						type="text"
						:formatter="formatter"
						required
					/>
				</b-form-group>
			</b-col>

			<b-col cols="6">
				<b-form-group
					label="Price:"
					for="price"
				>
					<b-input
						id="price"
						v-model="code.Price"
						type="text"
						required
					/>
				</b-form-group>
			</b-col>

			<b-col cols="4">
				<b-button
					type="submit"
					variant="info"
				>
					Add
				</b-button>
			</b-col>

			<b-col cols="6">
				<span
					class="text-danger"
					v-if="postError"
				>{{ postError }}</span>
			</b-col>

		</b-row>

	</b-form>
</template>


<script>
import InvoiceCodeService from "@/api-services/invoicecode.service";

export default {
	name: "AddInvoiceCode",

	// things we have inherited from our parent
	props: [],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			code: {
				Code: "",
				Price: "",
			},
			postError: "",
		};
	},

	// things we do to data
	methods: {
		add() {
			InvoiceCodeService.create(this.code)
				.then((response) => {
					// push this sucka back to the parent
					let newCode = response.data;
					this.$emit("addInvoiceCode", newCode);
				})
				.catch((error) => {
					this.postError = error.response.data.Message;
				});
		},

		formatter(value) {
			return value.toUpperCase();
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-invoicecode.vue